import { useContext } from 'react';

import { Card, Typography } from '@occc/ui-design-system';

import { LocationLog } from './location-log.component';

import { LocationContext } from '../LocationProvider';

export const LocationActivityLogContainer = () => {
  const { location } = useContext(LocationContext);

  if (!location) {
    return (
      <Card sx={{ py: 10, px: 2 }}>
        <Typography color='error' textAlign='center'>
          No data. Something went wrong. Please try again.
        </Typography>
      </Card>
    );
  }

  return (
    <Card sx={{ pt: 1, px: 0, pb: 2 }}>
      <LocationLog location={location} />
    </Card>
  );
};
